module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "survey-filter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('i-box', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h2', [_vm._v("Filter Builder")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-form', {
    attrs: {
      "label-width": "200px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$apollo.loading) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading surveys..."
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.surveys.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Survey")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSurvey),
      expression: "loadingSurvey"
    }],
    attrs: {
      "placeholder": "Please select a survey",
      "clearable": ""
    },
    on: {
      "change": _vm.handleSurveyChanged
    },
    model: {
      value: (_vm.filterData.survey_id),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "survey_id", $$v)
      },
      expression: "filterData.survey_id"
    }
  }, _vm._l((_vm.surveys), function(survey) {
    return _c('el-option', {
      key: survey.id,
      attrs: {
        "label": survey.title,
        "value": survey.id
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.filterData.survey_id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [(_vm.stageCountLoading.survey) ? _c('i', {
    staticClass: "pull-right fa fa-spinner fa-spin"
  }) : _c('span', {
    staticClass: "pull-right respondent-count"
  }, [_vm._v("Respondents: " + _vm._s(_vm.stageCount.survey.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.filterData.survey_id) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Demographics")]), _vm._v(" "), _vm._l((_vm.demographicQuestions), function(question) {
    return _c('div', {
      key: question.id
    }, [_c('el-form-item', {
      attrs: {
        "label": question.title
      }
    }, [(question.choiceLinks) ? _c('el-checkbox-group', {
      model: {
        value: (_vm.selectedDemographics),
        callback: function($$v) {
          _vm.selectedDemographics = $$v
        },
        expression: "selectedDemographics"
      }
    }, _vm._l((_vm.questionChoices(question.id)), function(choice) {
      return _c('el-checkbox', {
        key: choice.id,
        attrs: {
          "label": ((question.id) + ":" + (choice.choice.id))
        }
      }, [_vm._v(_vm._s(choice.choice.title) + " ")])
    }), 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.demographicQuestions.length === 0) ? _c('empty', [_vm._v("No demographics questions were asked on this survey.")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Contact details")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.fields),
      callback: function($$v) {
        _vm.fields = $$v
      },
      expression: "fields"
    }
  }, [_c('el-checkbox', {
    key: 'Mobile number',
    attrs: {
      "label": 'Mobile number'
    }
  }, [_vm._v("Mobile number")]), _vm._v(" "), _c('el-checkbox', {
    key: 'All',
    attrs: {
      "label": 'All'
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.contactQuestions), function(question) {
    return _c('el-checkbox', {
      key: question,
      attrs: {
        "label": question
      }
    }, [_vm._v(_vm._s(question))])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.stageCountLoading.demographics) ? _c('i', {
    staticClass: "pull-right fa fa-spinner fa-spin"
  }) : _c('span', {
    staticClass: "pull-right respondent-count"
  }, [_vm._v("Respondents: " + _vm._s(_vm.stageCount.demographics.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Questions")]), _vm._v(" "), _vm._l((_vm.filterData.questions), function(selectedQuestion, index) {
    return _c('div', {
      key: index,
      staticClass: "question"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Question"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Please select a question"
      },
      on: {
        "change": function($event) {
          return _vm.handleQuestionsChanged()
        }
      },
      model: {
        value: (selectedQuestion.question_id),
        callback: function($$v) {
          _vm.$set(selectedQuestion, "question_id", $$v)
        },
        expression: "selectedQuestion.question_id"
      }
    }, _vm._l((_vm.questions), function(question) {
      return _c('el-option', {
        key: question.id,
        attrs: {
          "label": question.title,
          "value": question.id,
          "disabled": _vm.isQuestionUsed(question.id)
        }
      })
    }), 1)], 1), _vm._v(" "), (_vm.questionChoices(selectedQuestion.question_id).length > 0) ? _c('el-form-item', {
      attrs: {
        "label": "Answers"
      }
    }, [_c('el-checkbox-group', {
      on: {
        "change": function($event) {
          return _vm.handleQuestionsChanged()
        }
      },
      model: {
        value: (selectedQuestion.choices),
        callback: function($$v) {
          _vm.$set(selectedQuestion, "choices", $$v)
        },
        expression: "selectedQuestion.choices"
      }
    }, _vm._l((_vm.questionChoices(selectedQuestion.question_id)), function(choice) {
      return _c('el-checkbox', {
        key: choice.choice.id,
        attrs: {
          "label": choice.choice.id,
          "value": choice.choice.id
        }
      }, [_vm._v(_vm._s(choice.choice.title))])
    }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "question-remove pull-right"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveQuestion(index)
        }
      }
    }, [_vm._v("[Remove]")])], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (
      _vm.filterData.questions.length > 1 && index !== _vm.filterData.questions.length - 1
    ) ? _c('div', {
      staticClass: "question-condition"
    }, [_vm._v("AND they must have answered...")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Add another question from this survey",
      "placement": "bottom"
    }
  }, [(_vm.unusedQuestions.length > 0) ? _c('el-button', {
    attrs: {
      "type": "success",
      "round": "",
      "circle": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddQuestion()
      }
    }
  }) : _vm._e()], 1)], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.stageCountLoading.questions) ? _c('i', {
    staticClass: "pull-right fa fa-spinner fa-spin"
  }) : _c('span', {
    staticClass: "pull-right respondent-count"
  }, [_vm._v("Respondents: " + _vm._s(_vm.stageCount.questions.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(this.filterData.survey_id) ? _c('el-button', {
    attrs: {
      "split-button": "",
      "type": "primary",
      "disabled": _vm.generatingList || _vm.isGenerateDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleGenerate()
      },
      "command": _vm.handleGenerateCommand
    }
  }, [(_vm.generatingList) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "else": ""
    }
  }, [_vm._v("Generate List")]), _vm._v(" "), _c('el-dropdown-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "constant_contact"
    }
  }, [_vm._v("Constant Contact")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mail_chimp"
    }
  }, [_vm._v("Mail Chimp")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.loadVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-folder-open-o"
  }), _vm._v(" Load\n                  ")]), _vm._v(" "), (this.filterData.survey_id) ? _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.saveVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-floppy-o"
  }), _vm._v(" Save\n                  ")]) : _vm._e()], 1)], 1)], 1)])])], 1)])], 1), _vm._v(" "), _c('survey-filter-save-dialog', {
    attrs: {
      "is-visible": _vm.saveVisible
    },
    on: {
      "onVisibleChanged": function($event) {
        _vm.saveVisible = $event
      },
      "onSave": _vm.handleSave
    }
  }), _vm._v(" "), _c('survey-filter-load-dialog', {
    attrs: {
      "is-visible": _vm.loadVisible
    },
    on: {
      "onVisibleChanged": function($event) {
        _vm.loadVisible = $event
      },
      "onLoad": _vm.handleLoad
    }
  }), _vm._v(" "), (_vm.constantContactVisible) ? _c('constant-contact-dialog', {
    attrs: {
      "contacts": _vm.constantContactList,
      "is-visible": _vm.constantContactVisible,
      "loadingContacts": _vm.loadingSurveyRespondents
    },
    on: {
      "open": _vm.getSurveyRespondents,
      "onVisibleChanged": function($event) {
        _vm.constantContactVisible = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mailChimpVisible) ? _c('mailchimp-dialog', {
    attrs: {
      "contacts": _vm.mailchimpContactList,
      "is-visible": _vm.mailChimpVisible,
      "loadingContacts": _vm.loadingSurveyRespondents
    },
    on: {
      "open": _vm.getSurveyRespondents,
      "onVisibleChanged": function($event) {
        _vm.mailChimpVisible = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h1', [_vm._v("Survey Filter")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-003caaaa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/SurveyFilter.vue
// module id = 3111
// module chunks = 3